/* DIY Bakery — Seitenübergang
   Der Vorhang deckt die Seite beim Laden ab und fährt nach oben weg.
   Beim Klick auf einen internen Link fährt er von unten wieder ein,
   erst danach wird navigiert.

   Grundsatz: Der Vorhang deckt den ganzen Bildschirm ab, darf die Seite
   also unter keinen Umständen blockieren. Deshalb
     - `pointer-events: none`, er faengt nie einen Klick ab,
     - kein requestAnimationFrame im kritischen Pfad (friert in
       Hintergrund-Tabs ein),
     - kein Warten auf `load` (haengt an der langsamsten Ressource),
     - und eine Notbremse, die ihn nach 2,5 s in jedem Fall oeffnet.

   Ohne JavaScript bekommt <html> nie die Klasse `pt` — dann bleibt der
   Vorhang unsichtbar und die Seite funktioniert ganz normal. */

(function () {
  "use strict";

  var root = document.documentElement;
  if (!root.classList.contains("pt")) return;          // reduzierte Bewegung oder kein JS
  if (window.Shopify && window.Shopify.designMode) {    // im Shopify-Customizer stören
    root.classList.add("pt-hidden", "pt-open");
    return;
  }

  var DAUER = 550;   // muss zur Übergangsdauer im CSS passen
  var geoeffnet = false;

  /* ---------- hereinkommen: Vorhang nach oben wegziehen ---------- */

  function oeffnen() {
    if (geoeffnet) return;
    geoeffnet = true;
    root.classList.remove("pt-leave");
    root.classList.add("pt-anim", "pt-open");
    setTimeout(function () { root.classList.add("pt-hidden"); }, DAUER + 100);
  }

  function starten() { setTimeout(oeffnen, 120); }      // kurz stehen lassen, dann weg

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", starten);
  } else {
    starten();
  }

  setTimeout(oeffnen, 2500);                            // Notbremse

  /* ---------- hinausgehen: Vorhang von unten einfahren ---------- */

  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = e.target.closest && e.target.closest("a");
    if (!a || a.target || a.hasAttribute("download")) return;

    var href = a.getAttribute("href");
    if (!href || href.charAt(0) === "#") return;

    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }

    if (url.protocol !== "http:" && url.protocol !== "https:") return;   // mailto:, tel:
    if (url.origin !== location.origin) return;                          // externe Links
    if (url.href === location.href) return;                              // gleiche Seite
    if (url.pathname === location.pathname &&
        url.search === location.search && url.hash) return;              // reiner Anker

    e.preventDefault();

    /* Vorhang ohne Übergang unter den Bildschirm setzen, Reflow erzwingen,
       dann mit Übergang auf 0 fahren — synchron, ohne rAF. */
    root.classList.remove("pt-hidden", "pt-open", "pt-anim");
    root.classList.add("pt-below", "pt-leave");
    void document.body.offsetHeight;
    root.classList.add("pt-anim");
    root.classList.remove("pt-below");

    setTimeout(function () { location.href = url.href; }, DAUER);
  });

  /* ---------- Zurück-Taste: Seite kommt aus dem bfcache ---------- */

  window.addEventListener("pageshow", function (e) {
    if (e.persisted) root.classList.add("pt-hidden", "pt-open");
  });
})();
